import styled from '@emotion/styled';

const StyledImg = styled.img({
  width: 50,
  height: 50,
  objectFit: 'contain'
});

export default StyledImg;
